module.exports = __webpack_public_path__ + "static/media/chris.62e466e0.png";